import { render, staticRenderFns } from "./OlympiadForm.vue?vue&type=template&id=6589c27e&scoped=true&lang=pug&"
import script from "./OlympiadForm.vue?vue&type=script&lang=js&"
export * from "./OlympiadForm.vue?vue&type=script&lang=js&"
import style0 from "./OlympiadForm.vue?vue&type=style&index=0&id=6589c27e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589c27e",
  null
  
)

export default component.exports